import { Spinner } from '@hopin-team/ui-spinner';
import { Mount, useHostSlice, useReactiveMap } from '@slicesjs/react-core';
import React from 'react';

export const SliceMount = ({ version }: { version: string }) => {
  const reactiveMap = useReactiveMap();
  const scopedMap = new Map<any, any>();

  const { mount, error } = useHostSlice({
    packageName: '@hopin-team/slice-schedules-registration',
    url: {
      version
    }
  });

  if (mount) {
    return (
      <Mount mount={mount} reactiveMap={reactiveMap} scopedMap={scopedMap} />
    );
  }

  if (error) {
    throw error;
  }

  return (
    <Spinner
      label="loading"
      pattern="jumbo"
      isAssertive
      isShowing
      m="auto"
      mt={1}
    />
  );
};
